import styled from "styled-components";

export const StyledOpenBankingSuccessStep = styled.div`
	max-width: 63rem;
`;